// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "3617d5f80",
    "hash": "3617d5f80",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3617d5f80",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "11/3/2026",
    "buildTime": "Tue, 03 Nov 2026 21:18:25 GMT"
};
/* eslint:enable */
